/* Guest-facing links: the magic link into their ticket page, and the RSVP form.
 *
 * These are built by concatenation rather than URLSearchParams on purpose. The
 * magic link carries raw `=`, `::` and `/` inside its query values, and the
 * working example ends with an empty `RefId=`. Encoding those would produce a
 * different URL from the one known to work, so the shape is reproduced exactly
 * as given. */

const SITE = 'https://digitalday.sinarmas.com';

/* A fixed tenant token that prefixes every ticket number in a magic link. It
   is not a secret — it decodes to "hyperjumpisonthehouseyo" — and it is the
   same for every guest, so it is not derived from anything. */
const MAGIC_PREFIX = 'aHlwZXJqdW1waXNvbnRoZWhvdXNleW8=';

/** Signs the guest straight into their own ticket page. */
export function magicLink(ticket, { redirect = '/my-ticket', refId = '' } = {}) {
  if (!ticket) return '';
  return `${SITE}/magic-link?ticketNumber=${MAGIC_PREFIX}::${ticket}` +
         `&redirect=${redirect}&RefId=${refId}`;
}

/**
 * The RSVP form, addressed to whichever contact the guest actually has.
 * Phone wins when both are present, as the ticketing side expects.
 * Returns '' when there is neither — 27 of 1,879 guests are in that state, and
 * a link with an empty contact would silently open a form addressed to nobody.
 */
export function rsvpLink(guest) {
  const ticket = guest?.ticket;
  if (!ticket) return '';
  const phone = (guest.phone || '').trim();
  const email = (guest.email || '').trim();
  if (phone) return `${SITE}/rsvp?phone_number=${encodeURIComponent(phone)}&ticket=${ticket}`;
  if (email) return `${SITE}/rsvp?email=${encodeURIComponent(email)}&ticket=${ticket}`;
  return '';
}

/** Which contact an RSVP link would use, for showing next to it. */
export function rsvpBasis(guest) {
  if ((guest?.phone || '').trim()) return { kind: 'phone', value: guest.phone.trim() };
  if ((guest?.email || '').trim()) return { kind: 'email', value: guest.email.trim() };
  return { kind: 'none', value: '' };
}
